import React, { useEffect, useState } from 'react';

import { Outlet, useLocation, useNavigate, useOutletContext } from 'react-router-dom';

import {

  SubHeaderContainer,

  LeftSide,

  RightSide,

  SectionName,

} from '../../../components/styles/subheader-style';

import {

  Content,

  ListContent,

  FormScrollArea,

  FormMainContainer,

} from './style';

import { FinancialEntriesOutletContext, FinancialEntryListFilters } from './types';

import { FINANCIAL_ENTRY_SORT_BY, FINANCIAL_VIEW_BY } from './constants';
import AppliedFiltersDisplay from '../../../components/SubHeaderFilter/AppliedFiltersDisplay';
import { financialEntryApi } from './api';
import { registerPaymentMethodCatalog } from '../../../utils/paymentMethodLabels';

import { TypeMainOutlet } from '..';

import {

  FinancialFormActionsProvider,

  useFinancialFormActions,

} from './FinancialFormActionsContext';

import { CancelButton, SaveButton } from './FinancialEntryForm/style';

import FinancialListHeader from './FinancialListHeader';
import {
  financialEntryRoutes,
  isFinancialEntryEditPath,
  isFinancialEntryFormPath,
} from './routes';



const FinancialFormSubHeader: React.FC<{
  isEditPage: boolean;
}> = ({ isEditPage }) => {
  const navigate = useNavigate();
  const { triggerSave, saving } = useFinancialFormActions();

  const formTitle = isEditPage ? 'Editar lançamento' : 'Novo lançamento';

  return (
    <SubHeaderContainer>
      <LeftSide>
        <SectionName>{formTitle}</SectionName>
      </LeftSide>
      <RightSide>
        <CancelButton type="button" onClick={() => navigate(financialEntryRoutes.list)}>
          Cancelar
        </CancelButton>
        <SaveButton type="button" disabled={saving} onClick={triggerSave}>
          {saving ? 'Salvando...' : isEditPage ? 'Salvar alterações' : 'Criar lançamento'}
        </SaveButton>
      </RightSide>
    </SubHeaderContainer>
  );
};



const FinancialEntriesLayoutInner: React.FC = () => {

  const location = useLocation();

  const parentContext = useOutletContext<TypeMainOutlet>();
  const navigate = useNavigate();

  const search = parentContext?.search ?? '';

  const [filters, setFilters] = useState<FinancialEntryListFilters>({

    sortBy: FINANCIAL_ENTRY_SORT_BY.CREATED_AT,

    viewBy: FINANCIAL_VIEW_BY.ENTRY,

    appliedFilters: [],

  });

  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    financialEntryApi
      .getPaymentMethods()
      .then(registerPaymentMethodCatalog)
      .catch(() => undefined);
  }, []);



  const isFormPage = isFinancialEntryFormPath(location.pathname);
  const isEditPage = isFinancialEntryEditPath(location.pathname);

  useEffect(() => {
    if (!isEditPage) return;
    const params = new URLSearchParams(location.search);
    if (params.get('readOnly') === 'true' || params.get('mode') === 'view') {
      navigate(financialEntryRoutes.list, { replace: true });
    }
  }, [isEditPage, location.search, navigate]);



  const triggerRefresh = () => setRefreshKey((k) => k + 1);



  const outletContext: FinancialEntriesOutletContext = {

    search,

    filters,

    setFilters,

    refreshKey,

    triggerRefresh,

  };



  const handleFiltersChange = (patch: Partial<FinancialEntryListFilters>) => {

    setFilters((prev) => ({ ...prev, ...patch }));

  };



  return (

    <>

      {isFormPage ? (

        <FinancialFormSubHeader isEditPage={isEditPage} />

      ) : (
        <>
          <FinancialListHeader filters={filters} onFiltersChange={handleFiltersChange} />
          <AppliedFiltersDisplay
            filters={filters.appliedFilters ?? []}
            onRemoveFilter={(index) =>
              setFilters((prev) => ({
                ...prev,
                appliedFilters: (prev.appliedFilters ?? []).filter((_, i) => i !== index),
              }))
            }
            onClearAll={() =>
              setFilters((prev) => ({
                ...prev,
                appliedFilters: [],
              }))
            }
          />
        </>
      )}



      {isFormPage ? (

        <Content>

          <FormScrollArea>

            <FormMainContainer>

              <Outlet context={outletContext} />

            </FormMainContainer>

          </FormScrollArea>

        </Content>

      ) : (

        <ListContent>

          <Outlet context={outletContext} />

        </ListContent>

      )}

    </>

  );

};



const FinancialEntriesLayout: React.FC = () => (

  <FinancialFormActionsProvider>

    <FinancialEntriesLayoutInner />

  </FinancialFormActionsProvider>

);



export default FinancialEntriesLayout;

